import { render, staticRenderFns } from "./versionNumber.vue?vue&type=template&id=8fdc0452&"
import script from "./versionNumber.vue?vue&type=script&lang=js&"
export * from "./versionNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports